/**
 * 栅格辅助线渲染层（无交互，pointer-events: none）
 */

import { computeGridGuideLines } from '@/components/canvas/workspace/overlays/gridGuides';
import type { GridGuideSettings } from '@/components/canvas/document/publicTypes';

interface GridGuideLayerProps {
  width: number;
  height: number;
  grid: GridGuideSettings;
  visible: boolean;
}

export function GridGuideLayer({ width, height, grid, visible }: GridGuideLayerProps) {
  if (!visible) return null;

  const { horizontal, vertical } = computeGridGuideLines(width, height, grid);
  const { margin } = grid;
  const contentHeight = Math.max(0, height - margin * 2);

  if (vertical.length === 0 && horizontal.length === 0 && margin <= 0) return null;

  return (
    <div className="pointer-events-none absolute inset-0 z-[1]" aria-hidden>
      {margin > 0 && (
        <div
          className="pointer-events-none absolute border border-dashed border-accent"
          style={{
            left: margin,
            top: margin,
            width: Math.max(0, width - margin * 2),
            height: contentHeight,
          }}
        />
      )}

      {vertical.map((x, i) => (
        <div
          key={`v-${i}-${x}`}
          className="absolute top-0 box-border h-full border-l border-accent"
          style={{ left: x }}
        />
      ))}
      {horizontal.map((y, i) => (
        <div
          key={`h-${i}-${y}`}
          className="absolute left-0 box-border w-full border-t border-accent"
          style={{ top: y }}
        />
      ))}
    </div>
  );
}
